/* import __COLOCATED_TEMPLATE__ from './project-details-activity.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { showModal } from 'sh-www/utils/modal-controls';
import { ACTION } from 'sh-www/models/action';
import { PROJECT_DETAILS__ACTIONS_WITH_PRIORITY } from 'sh-www/constants/routes/project-details';
import { APPLICATION_SOURCE } from 'sh-www/models/application';

class ProjectDetailsActivity extends Component {
  @service('commands/application-commands') applicationCommandService;
  @service('state-managers/application') applicationStateManager;
  @service('commands/thread-commands') threadCommandService;
  @service session;

  @tracked isAbsoluteTimeEnabled = false;

  get shouldObfuscate() {
    const { currentUser } = this.session;
    const { company } = this.args.application;
    return currentUser.isBuyer && company.isNeedsCreditCard;
  }

  get sortedActivitiesItems() {
    const { actions, thread } = this.args.application;
    const { messages } = thread;
    const allActivityItemsArr = [...actions.toArray(), ...messages.toArray()];

    allActivityItemsArr.sort((activityItemA, activityItemB) => {
      if (activityItemA.createdAt > activityItemB.createdAt) {
        return -1;
      } else if (activityItemA.createdAt < activityItemB.createdAt){
        return 1;
      } else {
        const actionsWithPriority = new Set(PROJECT_DETAILS__ACTIONS_WITH_PRIORITY);
        const isActivityANamePriority = actionsWithPriority.has(activityItemA.name);
        const isActivityBNamePriority = actionsWithPriority.has(activityItemB.name);
        if (isActivityANamePriority && !isActivityBNamePriority) {
          return -1;
        } else if (!isActivityANamePriority && isActivityBNamePriority) {
          return 1;
        }

        // Fixed response to ensure repeatability
        return activityItemA.id > activityItemB.id ? 1 : -1;
      }
    });

    return allActivityItemsArr;
  }

  markApplicationActivitiesAsViewed(messageID) {
    return this.applicationCommandService.markApplicationActivitiesViewed(
      this.args.application,
      messageID
    );
  }

  @action
  onSaveMessageClicked(newMessage, assetIDs) {
    return this.saveNewMessage.perform(this.args.application, newMessage, assetIDs)
      .then(() => {
        this.markApplicationActivitiesAsViewed();
      });
  }

  @task
  *saveNewMessage(application, newMessage, assetIDs = []) {
    try {
      const thread = application.thread;
      const includes = ['user','assets.uri-collection','actions'];
      yield this.threadCommandService.addNewMessageToThread(thread, newMessage, assetIDs, includes);
    } catch (e) {
      this.applicationStateManager.addToast('There was a problem sending message. Please try again');
    }
  }

  @action
  showProjectSummary(activity) {
    return activity.name === ACTION.NAMES.PROJECT_CREATE
      && activity.details?.[ACTION.META_CONSTANTS.ASSIGNMENT_SUMMARY]
      && activity.details?.[ACTION.META_CONSTANTS.ASSIGNMENT_DIRECT]
      && activity.details?.[ACTION.META_CONSTANTS.APPLICATION_SOURCE] === APPLICATION_SOURCE.QUOTE;
  }

  @action
  markThreadReadUpToMessage(messageID) {
    this.markApplicationActivitiesAsViewed(messageID);
  }

  @action
  showBuyerCreditCardCapture(e) {
    if (!this.shouldObfuscate) {
      return;
    }

    e.preventDefault();

    const application = this.args.application;
    const { seller } = application;
    showModal(this, 'payments/stripe-cc-modal', {
      seller,
      application,
    });
  }

  @action
  toggleActivityTimeMode() {
    this.isAbsoluteTimeEnabled = !this.isAbsoluteTimeEnabled;
  }
}

export default ProjectDetailsActivity;
